import type { JwtToken } from '../types/global';

export const send = async (
    url: string,
    method: 'get' | 'put' | 'post' | 'delete',
    jwt: JwtToken,
    body?: unknown,
) => {
    const headers: Record<string, string> = {
        'Content-Type': 'application/json',
    };

    if (jwt) {
        headers['Authorization'] = `Bearer ${jwt.token}`;
    }

    const response = await fetch(`${window.origin}${url}`, {
        method,
        headers,
        body: body ? JSON.stringify(body) : null,
    });

    return response;
};

const extractError = (parsedResponse: unknown) => {
    if (typeof parsedResponse === 'string') {
        return parsedResponse;
    }

    if (
        typeof parsedResponse === 'object' &&
        parsedResponse !== null &&
        'detail' in parsedResponse &&
        typeof parsedResponse.detail === 'string'
    ) {
        return parsedResponse.detail;
    }

    return JSON.stringify(parsedResponse);
};

export const fetchAndParse = async <T>(
    url: string,
    method: 'get' | 'put' | 'post' | 'delete',
    jwt: JwtToken,
    body?: unknown,
) => {
    const response = await send(url, method, jwt, body);

    if (response.status === 204) {
        return null as T;
    }

    if (response.status >= 400) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }

    const parsedResponse = await response.json();

    if (response.status >= 400) {
        throw new Error(extractError(parsedResponse));
    }

    return parsedResponse as T;
};
